import InputAdornment from '@mui/material/InputAdornment';
import moment from 'moment-timezone';
import thousands from 'thousands';
import common from './common';

export const headCells = [
  {
    id: 'receiptNumber',
    label: 'Receipt No.',
    width: 150,
  },
  {
    id: 'date',
    type: 'datetime',
    label: 'Date',
    width: 120,
    render: ({ row }) => {
      return moment(row.date).tz('Asia/Hong_Kong').format('DD/MM/YYYY');
    }
  },
  {
    id: 'amount',
    type: 'number',
    label: 'Amount',
    width: 120,
    render: ({ row }) => {
      return 'HKD ' + thousands((row.amount ?? 0).toFixed(2));
    },
  },
  {
    label: 'Download',
    type: 'actions',
    actions: ['download'],
  },
];


export const validationRules = {
  status: {},
  receiptName: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
  },
  receiptNumber: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
  },
  date: {
    required: common.validationRules.required,
    validate: common.validationRules.date,
  },
  documentUrl: {
    maxLength: common.validationRules.maxLength255,
    validate: (value) => {
      if (!value) return true;
      try {
        new URL(value);
        return true;
      } catch {
        return 'Invalid URL format';
      }
    },
  },
  amount: {
    required: common.validationRules.required,
    validate: (value) => {
      if (!value || isNaN(value)) return 'Amount must be a valid number';
      if (parseFloat(value) < 0.01) return 'Amount must be at least 0.01';
      return true;
    },
  },
  giverId: {
    required: common.validationRules.required,
  },
  remarks: {},
};


export const fields = {
  id: {
    name: 'id',
    type: 'hidden',
  },
  status: {
    name: 'status',
    label: 'Status',
    readOnly: true,
  },
  receiptName: {
    name: 'receiptName',
    label: 'Receipt Name',
    type: 'text',
  },
  receiptNumber: {
    name: 'receiptNumber',
    label: 'Receipt Number',
    type: 'text',
    readOnly: true,
  },
  date: {
    name: 'date',
    type: 'date',
    label: 'Date',
    defaultValue: moment().tz('Asia/Hong_Kong'),
  },
  documentUrl: {
    name: 'documentUrl',
    label: 'Document URL',
    type: 'text',
  },
  amount: {
    name: 'amount',
    label: 'Amount',
    type: 'number',
    startAdornment: <InputAdornment position="start">HKD</InputAdornment>,
  },
  giverId: {
    name: 'giverId',
    type: 'select',
    label: 'Giver',
  },
  givings: {
    name: 'givings',
    type: 'hidden',
    label: 'Giving',
    readOnly: true,
  },
  remarks: common.fields.remarks,
};


export const form = {
  create: [
    ['receiptName'],
    ['date', 'giverId'],
    ['amount'],
    ['documentUrl'],
    ['remarks'],
  ],
  edit: [
    ['receiptNumber'],
    ['receiptName'],
    ['date', 'giverId'],
    ['amount'],
    ['documentUrl'],
    ['remarks'],
  ],
  view: [
    ['receiptNumber'],
    ['receiptName'],
    ['date', 'giverId'],
    ['amount'],
    ['documentUrl'],
    ['givings'],
    ['remarks'],
  ],
};

export const optionFilters = [
  'giverId',
  'receiptNumber',
  'receiptName',
];

export default {
  validationRules,
  headCells,
  fields,
  form,
  optionFilters,
};
